import { FragmentTagsModel } from '@ve-pro/api/aside/type'
import type {
  GetAssetListParams,
  AssetListItem,
} from '@/api/public_resource/type'
import { loginAdvertiser } from '@/api/advertiser/manage'
import { RatioTypeUnion } from '@ve-pro/types/track.type'
import { computed } from 'vue'
import { playTurboHostList } from '@/config/host'
import { NODE_ENV } from '@com/config/env'
import _ from 'lodash'

const playTurboUrl = computed(() => {
  // @ts-ignore
  return `${playTurboHostList[NODE_ENV]}/#/auth`
})

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function editSearchQuery(query: any): GetAssetListParams {
  query.id = ''
  query.name = ''
  query.description = ''

  for (const key in query) {
    if (query['searchName'] === key) {
      query[key] = query.keyWords
    }
  }

  return query
}

export function getTreeHeight(): number {
  const table = document.getElementById('list-right')
  const tableHeight = table?.getBoundingClientRect()
  return tableHeight?.height ?? 0
}

// 查看标签对应的label
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getTemplateLabel(
  options: FragmentTagsModel[],
  tageIds: string,
  lastLevelNodes: FragmentTagsModel[] = [],
) {
  for (const option of options) {
    const tage_ids = tageIds && tageIds.split(',')

    if (!option.sub_tag || option.sub_tag.length === 0) {
      // @ts-ignore
      if (tage_ids.includes(option.id)) {
        lastLevelNodes.push(option)
      }
    } else {
      // @ts-ignore
      getTemplateLabel(option.sub_tag, tageIds, lastLevelNodes)
    }
  }

  return lastLevelNodes
}

// 封面图展示,优先主尺寸、尺寸radio、封面图的第一个展示
export function defaultCoverPreviews(s: AssetListItem) {
  if (s.cover_previews && JSON.stringify(s.cover_previews) !== '{}') {
    if (
      s.cover_previews['zh-cn'] &&
      JSON.stringify(s.cover_previews['zh-cn']) !== '{}'
    ) {
      return (
        s.cover_previews['zh-cn'][s.main_ratio as RatioTypeUnion] ||
        s.cover_previews['zh-cn'][s.ratio as RatioTypeUnion] ||
        Object.values(s.cover_previews['zh-cn'])[0]
      )
    } else if (
      s.cover_previews['en'] &&
      JSON.stringify(s.cover_previews['en']) !== '{}'
    ) {
      return (
        s.cover_previews['en'][s.main_ratio as RatioTypeUnion] ||
        s.cover_previews['en'][s.ratio as RatioTypeUnion] ||
        Object.values(s.cover_previews['en'])[0]
      )
    } else if (
      s.cover_previews[''] &&
      JSON.stringify(s.cover_previews['']) !== '{}'
    ) {
      return (
        s.cover_previews[''][s.main_ratio as RatioTypeUnion] ||
        s.cover_previews[''][s.ratio as RatioTypeUnion] ||
        Object.values(s.cover_previews[''])[0]
      )
    }
    return ''
  }
  return ''
}

// 查看项目---idg账号下打开视频编辑器
export async function handleViewProject(project_id: number) {
  let newTab = window.open('about:blank')
  const close = () => {
    if (newTab) {
      newTab.close()
      newTab = null
    }
  }
  try {
    const res = await loginAdvertiser({
      id: 9432, // idg广告主
    })
    if (res.data.code === 0) {
      const token = _.get(res, 'data.data.token') || ''
      // @ts-ignore
      newTab.location.href = `${playTurboUrl.value}?token=${token}&source_project=ve&source_project_id=${project_id}`
      newTab = null
    } else {
      close()
    }
  } catch (err) {
    close()
  }
}
